import * as types from 'template/actions/types'

const initialState = {
    selectedTemplateCategory: null,
    templateCategoryList: [],
    selectedTemplate: null,
    templateList: [],
    isLoading: true,
    hasErrors: false,
    errors: [],
    displaySearchResults: false,
    searchText: ''
}

export default function template(state = initialState, action) {
    switch (action.type) {
        case types.LOAD_TEMPLATE_CATEGORIES:
            return {
                ...state,
                isLoading: true
            }
        case types.LOAD_TEMPLATE_CATEGORIES_ERROR:
            return {
                ...state,
                isLoading: false,
                hasErrors: true,
                errors: action.errors
            }
        case types.LOAD_TEMPLATE_CATEGORIES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasErrors: false,
                templateCategoryList: action.templateCategoryList
            }
        case types.SELECT_TEMPLATE_CATEGORY:
            return {
                ...state,
                selectedTemplateCategory: action.selectedTemplateCategory,
                selectedTemplate: null
            }
        case types.DESELECT_TEMPLATE_CATEGORY:
            return {
                ...state,
                selectedTemplateCategory: null,
                templateList: []
            }
        case types.LOAD_TEMPLATE_LIST:
        case types.SEARCH_TEMPLATE_LIST:
            return {...state, isLoading: true}
        case types.SET_SEARCH_TEXT:
            return {...state, searchText: action.searchText}
        case types.LOAD_TEMPLATE_LIST_ERROR:
        case types.SEARCH_TEMPLATE_LIST_ERROR:
            return {...state, isLoading: false, hasErrors: true}
        case types.LOAD_TEMPLATE_LIST_SUCCESS:
            return {
                ...state,
                hasErrors: false,
                isLoading: false,
                templateList: action.templateList,
                displaySearchResults: false
            }
        case types.SEARCH_TEMPLATE_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasErrors: false,
                templateList: action.templateList,
                displaySearchResults: true
            }
        case types.SEARCH_TEMPLATE_LIST_RESET:
            return {
                ...state, isLoading: false,
                displaySearchResults: false,
                searchText: ''
            }
        case types.SELECT_TEMPLATE:
            return {
                ...state,
                selectedTemplate: action.manual
            }
        case types.DESELECT_TEMPLATE:
            return {
                ...state,
                selectedTemplate: null
            }
        case types.CREATE_TEMPLATE_CATEGORY:
            return {
                ...state
            }
        case types.CREATE_TEMPLATE_CATEGORY_SUCCESS:
            return {
                ...state
            }
        case types.CREATE_TEMPLATE_CATEGORY_ERROR:
            return {
                ...state,
                hasErrors: true,
                errors: action.errors
            }
        case types.UPDATE_TEMPLATE_CATEGORY:
            return {
                ...state,
                selectedTemplateCategory: action.category
            }
        case types.UPDATE_TEMPLATE_CATEGORY_SUCCESS:
            return {
                ...state
            }
        case types.UPDATE_TEMPLATE_CATEGORY_ERROR:
            return {
                ...state,
                hasErrors: true,
                errors: action.errors
            }
        case types.DELETE_TEMPLATE_CATEGORY:
            return {
                ...state
            }
        case types.DELETE_TEMPLATE_CATEGORY_SUCCESS:
            return {
                ...state,
                templateCategoryList: [],
                templateList: [],
                selectedTemplateCategory: null,
                selectedTemplate: null
            }
        case types.DELETE_TEMPLATE_CATEGORY_ERROR:
            return {
                ...state,
                hasErrors: true,
                errors: action.errors
            }
        case types.UPDATE_TEMPLATE:
            return {
                ...state,
                selectedTemplate: action.template
            }
        case types.SAVE_TEMPLATE_SUCCESS:
            return {
                ...state,
                templateList: action.templateList
            }
        case types.DELETE_TEMPLATE: // TODO
        case types.DELETE_TEMPLATE_SUCCESS: // TODO:
        case types.DELETE_TEMPLATE_ERROR:
        case types.SAVE_TEMPLATE:
        case types.SAVE_TEMPLATE_CATEGORY:
        default:
            return state
    }
}
